import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { DatePipe } from '@angular/common';

import * as moment from 'moment';
import jspdf from 'jspdf';
import html2canvas from 'html2canvas';
// import * as xlsx from 'xlsx';

import { Global } from '../../../../app.global';
import { Constants } from '../../helper/constants';
import { DepartmentReportsTextCopy } from '../../helper/textcopy/department-reports.text';
import { ReportsService } from '../../services/reports.service';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'department-reports',
  templateUrl: './department-reports.component.html',
  styleUrls: ['./department-reports.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class DepartmentReportsComponent implements OnInit {
  constants = Constants;
  reportsCopy = DepartmentReportsTextCopy;
  loadingState = false;
  dateRangeText = '';
  datePipeEn: DatePipe = new DatePipe('en-UK');

  selectedFilter = 'month';
  fromDate: Date = new Date();
  toDate: Date = new Date();
  currentDate = new Date();
  showCustomReportsDateRange = false;
  teamsReport = [];
  totalTeamsReport = {};

  constructor(
    public global: Global,
    private reportsService: ReportsService
  ) {}

  ngOnInit() {
    this.setTeamsReports();
    this.setReportDateRange();
  }

  onChangeFilter(filterName) {
    if (this.selectedFilter === filterName) {
      return;
    }
    this.selectedFilter = filterName;
    if (filterName !== 'custom') {
      this.updateReports(filterName);
    }
  }

  updateReports(filterName) {
    this.showCustomReportsDateRange = filterName === 'custom';
    this.setTeamsReports();
    this.setReportDateRange();
  }

  setTeamsReports() {
    this.loadingState = true;
    this.reportsService
      .getDepartmentPerformance(this.selectedFilter, this.fromDate, this.toDate)
      .subscribe(
        (result) => {
          this.teamsReport = this.reportsService.getFormattedTeamsDepartmentReport(result.data);
          this.totalTeamsReport = this.reportsService.getFormattedTotalTeamsDepartmentReport(
            result.total
          );

          this.loadingState = false;
        },
        (error) => {
          this.loadingState = false;
          console.log(error);
        }
      );
  }

  setReportDateRange() {
    this.dateRangeText = this.showCustomReportsDateRange
      ? `from ${this.datePipeEn.transform(this.fromDate, 'd MMMM y')}
        to ${this.datePipeEn.transform(this.toDate, 'd MMMM y')}`
      : `${this.selectedFilter} to ${this.datePipeEn.transform(this.currentDate, 'd MMMM y')}`;
  }

  downloadDocument(format) {
    if (format === 'excel') {
      const extraField = '';

      this.reportsService.exportExcelDocument(
        this.getTeamsReportExportJson(),
        this.getTeamsReportExportFields(),
        this.dateRangeText,
        extraField
      );
    } else {
      const reportsTable = document.getElementById('reports-table');
      const reportsTableClass = reportsTable.getAttribute('class');
      this.loadingState = true;
      reportsTable.classList.add('export-design');

      html2canvas(reportsTable, {
        scale: 3, // Increase the scale for better resolution
      }).then((canvas) => {
        const imgData = canvas.toDataURL('image/png');
        const pdf = new jspdf('landscape', 'pt', 'a4');
        const imgWidth = pdf.internal.pageSize.getWidth();
        const imgHeight = (canvas.height * imgWidth) / canvas.width;

        pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight, undefined, 'FAST'); // Set quality to 'FAST' for lower compression
        reportsTable.className = reportsTableClass;
        this.loadingState = false;
        pdf.save('reports.pdf');
      });
    }
  }

  getTeamsReportExportJson() {
    const dataList = [];

    this.teamsReport.forEach((team) => {
      dataList.push(this.reportsService.exportDepartmentObject(team));
    });
    dataList.push(this.reportsService.exportDepartmentObject(this.totalTeamsReport));

    return dataList;
  }

  getTeamsReportExportFields() {
    return [
      'team',
      'answered',
      'change',
      'of total',
      "canc'd",
      'bespoke',
      'override',
      'received',
      'quality change',
      'pp per day',
      'output rate change',
      'on letters',
    ];
  }
}
